module.exports = __webpack_public_path__ + "img/A20_20110171-001.12eff29f.jpg";